export const RECOMMENDATION_AMEND_UNDO_DELETE = "delete"
export const RECOMMENDATION_AMEND_UNDO_RESTORE = "restore"

export function buildRecommendationAmendUndoState({ existingAmend, savedAmend }) {
    if (!savedAmend?.id) return null

    const amendToRestore = buildExistingAmendRestoreInput(existingAmend)
    if (amendToRestore) {
        return {
            type: RECOMMENDATION_AMEND_UNDO_RESTORE,
            amend: amendToRestore,
        }
    }

    return {
        type: RECOMMENDATION_AMEND_UNDO_DELETE,
        amendId: savedAmend.id,
    }
}

function buildExistingAmendRestoreInput(existingAmend) {
    if (!existingAmend?.id || existingAmend?._isInherited) return null

    const payload = existingAmend?.payload ?? {}
    const recommendationSource = payload?.recommendationSource ?? {}

    return {
        amendsKey: payload?.amendsKey,
        content: payload?.content,
        internalContent: payload?.internalContent,
        externalContent: payload?.externalContent,
        noteMode: payload?.noteMode,
        recommendationId: recommendationSource?.recommendationId,
        sourceType: recommendationSource?.sourceType,
        sourceRecordId: recommendationSource?.sourceRecordId,
        sourceLabel: recommendationSource?.sourceLabel,
        sourceRoute: recommendationSource?.sourceRoute,
    }
}
